import { axiosMicroservice } from 'src/api/axios';

import type { TpTikTokPostParameters } from '../types/tiktok';

const FIRST_CLASS_OPTION_KEYS = [
  'value',
  'amount',
  'currency',
  'content_type',
  'description',
  'query',
  'order_id',
  'content_ids',
  'contents',
  'ph',
] as const;

const removeUndefinedValues = <T extends Record<string, any>>(value: T) =>
  Object.fromEntries(
    Object.entries(value).filter(([, entryValue]) => entryValue !== undefined),
  );

const splitTikTokOptions = ({
  options = {},
  customData = {},
}: Pick<TpTikTokPostParameters, 'options' | 'customData'>) => {
  const firstClassData: Record<string, any> = {};
  const remainingCustomData: Record<string, any> = { ...customData };

  for (const [key, value] of Object.entries(options)) {
    if ((FIRST_CLASS_OPTION_KEYS as readonly string[]).includes(key)) {
      firstClassData[key] = value;
      continue;
    }

    remainingCustomData[key] = value;
  }

  if (
    options.content_id != null &&
    firstClassData.content_ids == null &&
    remainingCustomData.content_ids == null
  ) {
    firstClassData.content_ids = [options.content_id];
    delete remainingCustomData.content_id;
  }

  return {
    firstClassData,
    customData: remainingCustomData,
  };
};

export const postTikTokEvent = async ({
  eventName,
  eventId,
  options,
  customData,
  email,
  phone,
  externalId,
  ttclid,
  ttp,
  eventSourceUrl,
  referrer,
}: TpTikTokPostParameters) => {
  const { firstClassData, customData: normalizedCustomData } =
    splitTikTokOptions({
      options,
      customData,
    });

  try {
    const { data } = await axiosMicroservice.post(
      'tiktok_event',
      removeUndefinedValues({
        origin: 'mimika',
        event_name: eventName,
        event_id: eventId,
        event_source_url: eventSourceUrl,
        referrer,
        email,
        phone,
        external_id: externalId,
        ttclid,
        ttp,
        ...firstClassData,
        custom_data: removeUndefinedValues(normalizedCustomData),
      }),
    );

    return data;
  } catch (error) {
    console.log(error);
  }
};
